export const SHOPPING_CART_LIST = 'SHOPPING_CART_LIST'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/shoppting-cart/store/mutations-types.js